import {
  ILoginDone,
  ILoginFailedAction,
  ILoginSuccessAction,
  ILogOutAction,
  IQRSignupSuccessAction,
  ISubmitLoginAction,
  LoginActionTypes,
} from "./loginTypes";

export function submitLogin(token: string): ISubmitLoginAction {
  return {
    type: LoginActionTypes.SUBMIT_LOGIN,
    token: token,
  };
}

export const loginSuccess = (): ILoginSuccessAction => {
  return {
    type: LoginActionTypes.LOGIN_SUCCESS,
    payload: {},
  };
};

export const qrSignupSuccess = (): IQRSignupSuccessAction => {
  return {
    type: LoginActionTypes.QR_SIGNUP_SUCCESS,
    payload: {},
  };
};

export const loginDone = (): ILoginDone => {
  return {
    type: LoginActionTypes.LOGIN_DONE,
  };
};

export const loginFailed = (err: any): ILoginFailedAction => {
  return {
    type: LoginActionTypes.LOGIN_FAILED,
  };
};

export const loginOut = (): ILogOutAction => {
  return {
    type: LoginActionTypes.LOGOUT,
  };
};
